import { computed, storeToRefs } from '#imports';
import { OrganizationDto } from '~/api/organizations';
import { useOrganizationStore } from '~/store/organization';

export const DEFAULT_LANDING_URL = '/';

export const resolveDefaultLandingUrl = (
  organization: OrganizationDto | null | undefined,
): string => {
  const configured = (organization?.organizationSettings as any)
    ?.defaultLandingUrl as string | null | undefined;
  return configured && configured.startsWith('/')
    ? configured
    : DEFAULT_LANDING_URL;
};

export const useDefaultLandingUrl = () => {
  const { organization } = storeToRefs(useOrganizationStore());
  return computed(() => resolveDefaultLandingUrl(organization.value));
};
